import { gql } from "@apollo/client"
import { STEP_FIELDS } from "./stepFieldsFragment"

const ACTION_FIELDS = gql`
  fragment ActionFields on Action {
    id
    title
    content
    users {
      id
      fullName
    }
    groups {
      id
      name
    }
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    location {
      id
      name
    }
    job {
      id
      title
      availableFrom
      displayName
      process {
        id
        name
      }
      location {
        id
        name
        timeZone
      }
    }
    jobStep {
      ...StepFields
    }
    workflow {
      id
      name
      type
      status
      severity
      locations {
        id
        name
        timeZone
      }
    }
    workflowStep {
      ...StepFields
    }
    priority
    status
    statusAt
    statusBy {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
    }
    note
    isOverdue @client
    dueAt
    author {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
      activeAt
    }
    comments {
      id
      content
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      author {
        id
        firstName
        lastName
        avatar {
          key
        }
        activeAt
      }
      createdAt
    }
    tags {
      id
      name
    }
    assets {
      id
      name
    }
    createdAt
    updatedAt
  }
  ${STEP_FIELDS}
`

export { ACTION_FIELDS }
